import { Symbol } from "@/components/fornada/brand";
import { Display, Label, Surface } from "@/components/fornada/primitives";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

type AndroidDownloadPageProps = {
  onContinueInBrowser: () => void;
};

const STEPS = [
  { n: "01", title: "Baixe o arquivo", text: "Abra este link pelo celular Android." },
  {
    n: "02",
    title: "Permita a instalação",
    text: "Autorize “fontes desconhecidas” quando o Android pedir.",
  },
  {
    n: "03",
    title: "Entre com sua conta",
    text: "Use o mesmo e-mail e senha da web.",
  },
];

export function AndroidDownloadPage({
  onContinueInBrowser,
}: AndroidDownloadPageProps) {
  const apkUrl = "/assets/pizza-cca.apk";

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-[880px] flex-col gap-7 px-5 py-10 min-[960px]:px-14 min-[960px]:py-12">
      <div className="flex flex-col gap-4 min-[960px]:flex-row min-[960px]:items-center min-[960px]:gap-4">
        <Symbol size={72} />
        <div className="flex flex-col gap-1.5">
          <Label className="text-[10.5px] tracking-[1.5px]">Android · Aplicativo</Label>
          <Display size="xl" className="min-[960px]:text-[44px] min-[960px]:leading-10">
            Baixe o app Fornada
          </Display>
        </div>
      </div>

      <p className="max-w-[560px] text-[15px] leading-[22px] text-fx-secondary">
        Registre pedidos direto do celular, mesmo durante a missa ou na porta da casa do cliente.
      </p>

      <div className="flex flex-col gap-3 min-[960px]:flex-row">
        <Button asChild size="xl">
          <a href={apkUrl} download>
            <Download size={20} /> Baixar APK
          </a>
        </Button>
        <Button variant="quiet" size="xl" onClick={onContinueInBrowser}>
          Continuar na web
        </Button>
      </div>

      <div className="mt-auto grid gap-3 pt-6 min-[960px]:grid-cols-3">
        {STEPS.map((s) => (
          <Surface key={s.n} className="flex flex-col gap-2.5 p-[18px]">
            <span className="fx-num text-[32px] leading-[30px] text-fx-red-icon">{s.n}</span>
            <span className="text-sm font-semibold text-fx-title">{s.title}</span>
            <span className="text-[12.5px] leading-[18px] text-fx-faint">{s.text}</span>
          </Surface>
        ))}
      </div>
    </div>
  );
}
